import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Edit, Trash2 } from "react-feather";
import Table from "../../core/pagination/datatable";
import PageHeader from "../components/PageHeader";
import confirmDelete from "../components/confirmDelete";
import ToothModal from "../../core/modals/tooth/ToothModal";
import { fetchTeeth, deleteToothThunk } from "../../core/redux/slices/toothSlice";

const ToothList = () => {
  const dispatch = useDispatch();
  const { list, loading } = useSelector((s) => s.tooth);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editRecord, setEditRecord] = useState(null);

  useEffect(() => { dispatch(fetchTeeth()); }, [dispatch]);

  const data = useMemo(() => {
    const q = search.toLowerCase();
    return list.filter((t) => !q || t.toothName?.toLowerCase().includes(q));
  }, [list, search]);

  const openAdd = () => { setEditRecord(null); setShowModal(true); };
  const openEdit = (rec) => { setEditRecord(rec); setShowModal(true); };
  const closeModal = () => { setShowModal(false); setEditRecord(null); dispatch(fetchTeeth()); };

  const columns = [
    { title: "Tooth Name", dataIndex: "toothName", sorter: (a, b) => a.toothName.localeCompare(b.toothName) },
    {
      title: "Action", dataIndex: "action", width: 100,
      render: (_, rec) => (
        <div className="edit-delete-action d-flex">
          <button className="me-2 p-2 btn btn-sm" onClick={() => openEdit(rec)}><Edit size={15} /></button>
          <button className="p-2 btn btn-sm text-danger" onClick={() => confirmDelete(() => dispatch(deleteToothThunk(rec.id)), rec.toothName)}>
            <Trash2 size={15} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <PageHeader title="Tooth" subtitle="Manage tooth master list" onAdd={openAdd} addLabel="Add Tooth" />
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-input">
                <input type="text" placeholder="Search tooth..."
                  className="form-control form-control-sm formsearch"
                  value={search} onChange={(e) => setSearch(e.target.value)} />
              </div>
            </div>
            <div className="table-responsive">
              <Table columns={columns} dataSource={data} loading={loading} />
            </div>
          </div>
        </div>
      </div>
      <ToothModal show={showModal} onClose={closeModal} editRecord={editRecord} />
    </div>
  );
};

export default ToothList;
